import {Control, FieldValues} from "react-hook-form";
import React, {useMemo} from "react";
import {getAutocompleteSupervisors} from "../../common/util/helpers";
import {useTranslation} from "react-i18next";
import {useTableWithAdjustableOrder} from "../../common/components/table/useTableWithAdjustableOrder";
import {BasicUser, Site} from "../../app/types";
import {formatUserInDropdown} from "../../common/util/formatters";
import FormRow from "../../common/form/FormRow";
import FormFieldBox from "../../common/form/FormFieldBox";
import {Paper} from "@mui/material";
import FormGroup from "../../common/form/FormGroup";

type Props<T extends FieldValues> = {
    control: Control<T>
    site : Site | null
}

export default function SupervisorSelection<T extends FieldValues> ({control, site} : Props<T>){
    const { t } = useTranslation()

    const supervisorOptionParams = useMemo(() =>
            getAutocompleteSupervisors(
                t('flows.edit.no-users-found'),
                [],
                site)
        , [site, t])

    const { table: SupervisorTable, selector: SupervisorSelector } = useTableWithAdjustableOrder<BasicUser>('supervisors', supervisorOptionParams, control, formatUserInDropdown, user => user.uuid, t('users.edit.user-select-button'), true)

    return <FormGroup label={t('flows.edit.section.supervisors')} fullWidth={true} >
            <FormRow>
                <FormFieldBox mdSize={8} lgSize={6}>
                    {SupervisorSelector}
                </FormFieldBox>
            </FormRow>
            <FormRow>
                <FormFieldBox mdSize={12}>
                    <Paper elevation={2}>
                        <SupervisorTable />
                    </Paper>
                </FormFieldBox>
            </FormRow>
        </FormGroup>

}